import { z } from "zod";
export const uuidSchema = z.string().uuid();
export const createOrganizationSchema = z.object({
    name: z.string().trim().min(2).max(120),
    legalName: z.string().trim().max(180).optional(),
    countryCode: z.string().length(2).default("FR")
});
export const createFarmSchema = z.object({
    name: z.string().trim().min(2).max(120),
    registrationNumber: z.string().trim().max(40).optional(),
    address: z.string().trim().max(240).optional(),
    totalAreaHa: z.number().nonnegative().max(1_000_000).optional()
});
export const createFieldSchema = z.object({
    farmId: uuidSchema,
    name: z.string().trim().min(2).max(120),
    reference: z.string().trim().max(60).optional(),
    areaHa: z.number().positive().max(1_000_000),
    cropName: z.string().trim().max(120).optional()
});
export const updateFieldSchema = createFieldSchema.partial().extend({
    status: z.enum(["active", "archived"]).optional()
});
